import { Subject } from "rxjs";
import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { SupplierState } from "../store/state/supplierstate.state";
import { SelectCurrentUser, SelectSupplierContactList, SelectValidationTask } from "../store/app.selector";
import { combineLatest } from 'rxjs';
import { takeUntil } from "rxjs/operators";
import { GetSupplierContactListByCode, GetSupplierProfileCurrentUser, GetValidationTaskByCode } from "../store/app.actions";
import { Router } from "@angular/router";
import { isNullOrEmpty, isNullOrUndefined, showMFADialog } from "app/shared/utils/utils";
import { SupplierContactPropertyValue } from "../models/supplier.model";
import { MfaBannerComponent } from "./mfa-banner/mfa-banner.component";
import { TslDialog } from "@tesla/ng-tds";

@Component({ selector: 'app-base', template: '<div></div>' })
export class BaseComponent implements OnDestroy {
    ngUnsubscribe = new Subject<void>();
    private checkPCFDocument: boolean = true;
    private isPrimaryContactModified: boolean = false;
    private isPCFValidationInProgress: boolean = false;
    showMFADialog: boolean = false;
    get isPCFUploaded() {
        return this.checkPCFDocument;
    }

    get isPCFValidationInReview(){
        return this.isPCFValidationInProgress;
    }

    PrimaryContactDocument(
        store: Store<SupplierState>,
        router: Router,
        supplierCode: string,
        redirect: boolean = true,
        redirectPCFValidationInProgress : boolean = false
    ) {
        store.dispatch(new GetSupplierContactListByCode(supplierCode));
        store.dispatch(new GetSupplierProfileCurrentUser());

        combineLatest([store.pipe(select(SelectSupplierContactList)), store.pipe(select(SelectCurrentUser))])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(([contacts, user]) => {
                if (contacts && user && user.isSupplier) {
                    const primaryContactUser = contacts.find(
                        (x) => x.types && x.types.newValue && x.types.newValue.includes('Primary'),
                    );
                    if (this.showPcfBanner(primaryContactUser)) {
                        this.checkPCFDocument = false;
                        if (redirect) {
                            router.navigateByUrl(`${supplierCode}/Contacts`);
                        }
                    } else {
                        if(this.isPrimaryContactModified){
                            this.isPCFValidationInProgress = this.checkIfPCFValidationIsInProgress(primaryContactUser);
                            if(redirectPCFValidationInProgress)
                            {
                                router.navigateByUrl(`${supplierCode}/Contacts`);
                            }
                        }
                        this.checkPCFDocument = true;
                    }
                }
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    showPcfBanner(primaryContactUser: SupplierContactPropertyValue) {
        if (isNullOrUndefined(primaryContactUser) || isNullOrEmpty(primaryContactUser)) {
            return true;
        }

        if (
            primaryContactUser.operation &&
            !isNullOrUndefined(primaryContactUser.operation.newValue) &&
            !isNullOrEmpty(primaryContactUser.operation.newValue)
        ) {
            this.isPrimaryContactModified = true;
            return false;
        }

        if (primaryContactUser?.isMFAEnrolled?.newValue) {
            return false;
        }

        if (primaryContactUser?.documents?.newValue?.length > 0) {
            return false;
        } else {
            return true;
        }
    }

    checkIfPCFValidationIsInProgress(primaryContactUser: SupplierContactPropertyValue){
        if (primaryContactUser?.isMFAEnrolled?.newValue) {
            return false;
        }
        if (primaryContactUser?.hasApprovedPcfOnFile?.newValue == true) {
            return false;
        }else{
            return true;
        }
    }


    showMFANotificationDialog(supplierCode: string, supplierContacts: SupplierContactPropertyValue[], dialog: TslDialog) {
        const dialogRef = dialog.open(MfaBannerComponent, {
            width: '50%',
            data: { supplierCode: supplierCode, supplierContacts: supplierContacts },
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res) {
                window.location.reload();
            }
        });
    }
}
